import React, { useEffect, useState } from 'react';

import { useSnackbar } from 'notistack';

import MyAccount from '../../components/myAccount/MyAccount';
import ValidationException from '../../exceptions/ValidationException';
import useBlocRef from '../../utils/useBlocRef.hook';

export default () => {
  const blocRef = useBlocRef('myAccountBloc');
  const [userDetails, setUserDetails] = useState(blocRef.current.userDetails$.getValue());
  const [validationErrors, setValidationErrors] = useState({});
  const { enqueueSnackbar } = useSnackbar();

  const handleRequestUpdateEmail = () => blocRef.current.requestEmailChange();

  useEffect(() => {
    const sub = blocRef.current.userDetails$.subscribe(setUserDetails);
    return () => sub.unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateDetails = async (data) => {
    try {
      await blocRef.current.updateDetails(data);
    } catch (exception) {
      if (exception instanceof ValidationException) {
        setValidationErrors(exception.errors);
      } else {
        enqueueSnackbar(exception.message, { autoHideDuration: 10000, variant: 'error' });
      }
    }
  };
  const changePassword = async ({ currentPassword, newPassword }) => {
    try {
      await blocRef.current.changePassword(currentPassword, newPassword);
    } catch (exception) {
      if (exception instanceof ValidationException) {
        setValidationErrors(exception.errors);
      } else {
        enqueueSnackbar(exception.message, { autoHideDuration: 10000, variant: 'error' });
      }
    }
  };

  return (
    <MyAccount
      userDetails={userDetails || {}}
      onUpdate={updateDetails}
      onRequestUpdateEmail={handleRequestUpdateEmail}
      onChangePassword={changePassword}
      validationErrors={validationErrors}
    />
  );
};
